
import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { API_ROUTES } from "../utils/utils";
import { IncoMeasureUpdateRequest } from "../interfaces/investmentcontrolling/inco-measure-update";
import { Project } from "../interfaces/investmentcontrolling/inco-project";
import { IncoActualReportingResponse, IncoActualValidationMeasuresResponse } from "../interfaces/investmentcontrolling/inco-actual-reporting-response";
import { IncoOplReportingResponse, IncoOplValidationMeasuresResponse } from "../interfaces/investmentcontrolling/inco-opl-reporting-response";
import { IncoUserSearchResult } from "../interfaces/investmentcontrolling/inco-user-search-result";

@Injectable()
export class InvestmentControllingService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject('BASE_URL') private readonly baseUrl: string
  ) { }


  //#region Master Data
  
  getProjectPhase(
    tthis: any = undefined,
    callback: any = undefined,
    callbackError: any = undefined) {
    const url = this.baseUrl + API_ROUTES.API_INCO + '/projectPhase';
    this.httpClient.get<any>(url).subscribe({
      next: (result) => {
        if (tthis && callback)
          callback(tthis, result);
      },
      error: (error) => {
        callbackError(tthis, error);
      }
    });
  }

  getInvestmentType(
    tthis: any = undefined,
    callback: any = undefined,
    callbackError: any = undefined) {
    const url = this.baseUrl + API_ROUTES.API_INCO + '/investmentType';
    this.httpClient.get<any>(url).subscribe({
      next: (result) => {
        if (tthis && callback)
          callback(tthis, result);
      },
      error: (error) => {
        callbackError(tthis, error);
      }
    });
  }

  getMultiprojects(
    tthis: any = undefined,
    callback: any = undefined,
    callbackError: any = undefined) {
    const url = this.baseUrl + API_ROUTES.API_INCO + '/multiproject';
    this.httpClient.get<any>(url).subscribe({
      next: (result) => {
        if (tthis && callback)
          callback(tthis, result);
      },
      error: (error) => {
        callbackError(tthis, error);
      }
    });
  }
  
  addMultiproject(
    request: { name: string },
    tthis: any = undefined,
    callback: any = undefined,
    callbackError: any = undefined) {
    const url = this.baseUrl + API_ROUTES.API_INCO + '/multiproject';
    this.httpClient.post<any>(url, request).subscribe({
      next: (result) => {
        if (tthis && callback)
          callback(tthis, result);
      },
      error: (error) => {
        if (callbackError)
          callbackError(tthis, error);
      }
    });
  }

  updateMultiproject(
    id: number,
    request: { name: string },
    tthis: any = undefined,
    callback: any = undefined,
    callbackError: any = undefined) {
    const url = this.baseUrl + API_ROUTES.API_INCO + `/multiproject/${id}`;
    this.httpClient.put<any>(url, request).subscribe({
      next: (result) => {
        if (tthis && callback)
          callback(tthis, result);
      },
      error: (error) => {
        if (callbackError)
          callbackError(tthis, error);
      }
    });
  }

  UpdateMultiprojectStatus(
    id: number,
    isEnabled: boolean,
    tthis: any = undefined,
    callback: any = undefined,
    callbackError: any = undefined) {
    const url = this.baseUrl + API_ROUTES.API_INCO + `/multiproject/${id}/status/${isEnabled}`;
    this.httpClient.put<any>(url, null).subscribe({
      next: (result) => {
        if (tthis && callback)
          callback(tthis, result);
      },
      error: (error) => {
        if (callbackError)
          callbackError(tthis, error);
      }
    });
  }

  loadMasterData(
    tthis: any = undefined,
    callback: any = undefined,
    callbackError: any = undefined) {
    const url = this.baseUrl + API_ROUTES.API_INCO + '/projectsByMgmt';
    this.httpClient.get<any>(url).subscribe({
      next: (result) => {
        if (tthis && callback)
          callback(tthis, result);
      },
      error: (error) => {
        callbackError(tthis, error);
      }
    });
  }

  getAllProjects(
    tthis: any = undefined,
    onlyRecent: boolean = false,
    callback: any = undefined,
    callbackError: any = undefined) {
    const url = this.baseUrl + API_ROUTES.API_INCO + `/projects/all/${onlyRecent}`;
    this.httpClient.get<Project[]>(url).subscribe({
      next: (result) => {
        if (tthis && callback)
          callback(tthis, result);
      },
      error: (error) => {
        if (tthis && callbackError)
          callbackError(tthis, error);
      }
    });
  }

  addMasterData(
    request: Project,
    tthis: any = undefined,
    callback: any = undefined,
    callbackError: any = undefined) {
    const url = this.baseUrl + API_ROUTES.API_INCO + '/postProject';
    this.httpClient.post<any>(url, request).subscribe({
      next: (result) => {
        if (tthis && callback)
          callback(tthis, result);
      },
      error: (error) => {
        callbackError(tthis, error);
      }
    });
  }

  updateMasterData(
    request: Project,
    tthis: any = undefined,
    callback: any = undefined,
    callbackError: any = undefined) {
    const url = this.baseUrl + API_ROUTES.API_INCO + '/updateProject';
    this.httpClient.post<any>(url, request).subscribe({
      next: (result) => {
        if (tthis && callback)
          callback(tthis, result);
      },
      error: (error) => {
        callbackError(tthis, error);
      }
    });
  }
  
  getProjectHistory(
    projectId: number,
    tthis: any | undefined = undefined,
    callback: ((tthis: any, result: any[]) => void) | undefined = undefined,
    callbackError: ((tthis: any, error: any) => void) | undefined = undefined
  ) {
    const url = this.baseUrl + API_ROUTES.API_INCO + `/project-history/${projectId}`;
    this.httpClient.get<any[]>(url).subscribe({
      next: (result) => {
        if (tthis && callback)
          callback(tthis, result);
      },
      error: (error) => {
        if (callbackError)
          callbackError(tthis, error);
      }
    });
  }

  upsertFunctionalAssignment(
    assignments: { mgmtId: string; category: string | null }[],
    tthis: any | undefined = undefined,
    callback: ((tthis: any, result: any) => void) | undefined = undefined,
    callbackError: ((tthis: any, error: any) => void) | undefined = undefined
  ) {
    const url = this.baseUrl + API_ROUTES.API_INCO + `/functional-assignment/upsert`;
    this.httpClient.post<any>(url, assignments).subscribe({
      next: (result) => {
        if (tthis && callback)
          callback(tthis, result);
      },
      error: (error) => {
        if (callbackError)
          callbackError(tthis, error);
      }
    });
  }

  getFunctionalAssignment(
    tthis: any | undefined = undefined,
    callback: ((tthis: any, result: any[]) => void) | undefined = undefined,
    callbackError: ((tthis: any, error: any) => void) | undefined = undefined
  ) {
    const url = this.baseUrl + API_ROUTES.API_INCO + `/functional-assignment`;
    this.httpClient.get<any[]>(url).subscribe({
      next: (result) => {
        if (tthis && callback)
          callback(tthis, result);
      },
      error: (error) => {
        if (callbackError)
          callbackError(tthis, error);
      }
    });
  }

  getMaintenanceExpansion(
    projectVersion: 'ACTUAL' | 'BUDGET' = 'ACTUAL',
    inputFiscalYear: number | null = null,
    tthis: any = undefined,
    callback: ((tthis: any, result: any[]) => void) | undefined = undefined,
    callbackError: ((tthis: any, error: any) => void) | undefined = undefined
  ) {
    let url = this.baseUrl + API_ROUTES.API_INCO + `/maintenance-expansion?projectVersion=${projectVersion}`;
    if (inputFiscalYear != null) {
      url += `&inputFiscalYear=${inputFiscalYear}`;
    }
    this.httpClient.get<any[]>(url).subscribe({
      next: (result) => {
        if (tthis && callback)
          callback(tthis, result);
      },
      error: (error) => {
        if (callbackError)
          callbackError(tthis, error);
      }
    });
  }

  saveMaintenanceExpansion(
    payload: { projectId: number; projectTitle: string; entries: { projectId: number; fiscalYear: number; maintenance: number; expansion: number; }[] }[],
    projectVersion: 'ACTUAL' | 'BUDGET' = 'ACTUAL',
    inputFiscalYear: number | null = null,
    tthis: any = undefined,
    callback: ((tthis: any, result: any) => void) | undefined = undefined,
    callbackError: ((tthis: any, error: any) => void) | undefined = undefined
  ) {
    let url = this.baseUrl + API_ROUTES.API_INCO + `/maintenance-expansion/upsert?projectVersion=${projectVersion}`;
    if (inputFiscalYear != null) {
      url += `&inputFiscalYear=${inputFiscalYear}`;
    }
    this.httpClient.post<any>(url, payload).subscribe({
      next: (result) => {
        if (tthis && callback)
          callback(tthis, result);
      },
      error: (error) => {
        if (callbackError)
          callbackError(tthis, error);
      }
    });
  }

  addMaintenanceExpansionProject(
    projectId: number,
    projectVersion: 'ACTUAL' | 'BUDGET' = 'ACTUAL',
    tthis: any = undefined,
    callback: ((tthis: any, result: any) => void) | undefined = undefined,
    callbackError: ((tthis: any, error: any) => void) | undefined = undefined
  ) {
    const url = this.baseUrl + API_ROUTES.API_INCO + `/maintenance-expansion/project/${projectId}?projectVersion=${projectVersion}`;
    this.httpClient.post<any>(url, null).subscribe({
      next: (result) => {
        if (tthis && callback)
          callback(tthis, result);
      },
      error: (error) => {
        if (callbackError)
          callbackError(tthis, error);
      }
    });
  }

  removeMaintenanceExpansionProject(
    projectId: number,
    projectVersion: 'ACTUAL' | 'BUDGET' = 'ACTUAL',
    tthis: any = undefined,
    callback: ((tthis: any, result: any) => void) | undefined = undefined,
    callbackError: ((tthis: any, error: any) => void) | undefined = undefined
  ) {
    const url = this.baseUrl + API_ROUTES.API_INCO + `/maintenance-expansion/project/${projectId}?projectVersion=${projectVersion}`;
    this.httpClient.delete<any>(url).subscribe({
      next: (result) => {
        if (tthis && callback)
          callback(tthis, result);
      },
      error: (error) => {
        if (callbackError)
          callbackError(tthis, error);
      }
    });
  }


  //#endregion

  //#region GET Actual Reporting

  loadActualProjects(
    branchId: string,
    fiscalYear: number,
    quarter: number,
    tthis: any = undefined,
    callback: ((tthis: any, result: IncoActualReportingResponse) => void) | undefined = undefined,
    callbackError: ((tthis: any, error: any) => void) | undefined = undefined) {
    
    const url = this.baseUrl + API_ROUTES.API_INCO + '/actuals/projects';
    const params = new HttpParams()
      .set('branchId', branchId)
      .set('fiscalYear', fiscalYear.toString())
      .set('quarter', quarter.toString());

    this.httpClient.get<IncoActualReportingResponse>(url, { params }).subscribe({
      next: (result) => {
        if (tthis && callback)
          callback(tthis, result);
      },
      error: (error) => {
        if (callbackError)
          callbackError(tthis, error);
      }
    });
  }

  //#region GET OPL Reporting

  loadOplProjects(
    branchId: string,
    fiscalYear: number,
    tthis: any = undefined,
    callback: ((tthis: any, result: IncoOplReportingResponse) => void) | undefined = undefined,
    callbackError: ((tthis: any, error: any) => void) | undefined = undefined) {
    
    const url = this.baseUrl + API_ROUTES.API_INCO + '/opl/projects';
    const params = new HttpParams()
      .set('branchId', branchId)
      .set('fiscalYear', fiscalYear.toString());

    this.httpClient.get<IncoOplReportingResponse>(url, { params }).subscribe({
      next: (result) => {
        if (tthis && callback)
          callback(tthis, result);
      },
      error: (error) => {
        if (callbackError)
          callbackError(tthis, error);
      }
    });
  }

  //#endregion

  //#region POST

  saveMeasures(
    measures: IncoMeasureUpdateRequest[],
    tthis: any = undefined,
    callback: ((tthis: any, result: any) => void) | undefined = undefined,
    callbackError: ((tthis: any, error: any) => void) | undefined = undefined) {
    
    const url = this.baseUrl + API_ROUTES.API_INCO + '/measures';
    this.httpClient.post<any>(url, measures).subscribe({
      next: (result) => {
        if (tthis && callback)
          callback(tthis, result);
      },
      error: (error) => {
        if (callbackError)
          callbackError(tthis, error);
      }
    });
  }

  //#endregion

  //#region Focus Projects

  loadFocusProjects(
    tthis: any = undefined,
    callback: any = undefined,
    callbackError: any = undefined) {
    const url = this.baseUrl + API_ROUTES.API_INCO + '/focusProjects';
    this.httpClient.get<any>(url).subscribe({
      next: (result) => {
        if (tthis && callback)
          callback(tthis, result);
      },
      error: (error) => {
        callbackError(tthis, error);
      }
    });
  }
  //#endregion

  //#region Validation

  loadOplValidation(
    fiscalYear: number,
    tthis: any = undefined,
    callback: ((tthis: any, result: IncoOplValidationMeasuresResponse) => void) | undefined = undefined,
    callbackError: ((tthis: any, error: any) => void) | undefined = undefined) {

    const url = this.baseUrl + API_ROUTES.API_INCO + `/opl/validation/${fiscalYear}`;

    this.httpClient.get<IncoOplValidationMeasuresResponse>(url).subscribe({
      next: (result) => {
        if (tthis && callback)
          callback(tthis, result);
      },
      error: (error) => {
        if (callbackError)
          callbackError(tthis, error);
      }
    });
  }
  
  loadActValidation(
    fiscalYear: number,
    period: number,
    tthis: any = undefined,
    callback: ((tthis: any, result: IncoActualValidationMeasuresResponse) => void) | undefined = undefined,
    callbackError: ((tthis: any, error: any) => void) | undefined = undefined) {

    const url = this.baseUrl + API_ROUTES.API_INCO + `/act/validation/${fiscalYear}/${period}`;

    this.httpClient.get<IncoActualValidationMeasuresResponse>(url).subscribe({
      next: (result) => {
        if (tthis && callback)
          callback(tthis, result);
      },
      error: (error) => {
        if (callbackError)
          callbackError(tthis, error);
      }
    });
  }
  //#endregion

  //#region User Search

  getIncoUsers(
    tthis: any = undefined,
    callback: ((tthis: any, result: IncoUserSearchResult[]) => void) | null | undefined = undefined,
    callbackError: ((tthis: any, error: any) => void) | null | undefined = undefined) {
    const url = this.baseUrl + API_ROUTES.API_INCO + '/users';
    this.httpClient.get<IncoUserSearchResult[]>(url).subscribe({
      next: (result) => {
        if (tthis && callback)
          callback(tthis, result);
      },
      error: (error) => {
        if (callbackError)
          callbackError(tthis, error);
      }
    });
  }
  //#endregion
}
